import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from '@tolgee/react';
import {
  GRADUATION_STRATEGY_MANUAL,
  GRADUATION_STRATEGY_SS_PERFORMANCE
} from '../config/constants';
import { POST_TYPE_TRIAL_REEL_KEY } from '../config/platformFeatures';
import { setPostDataAttribute } from '../../../redux/slices/lomavisCreator/lomavisCreator';

import { lomavisCreatorRootState } from '../../../pages/lomavisCreator';
import { INSTAGRAM } from '@/config/constants';
import { CreatorVerticalSeparator } from './include/VerticalSeperator';
import CreatorCard from './commonElements/creatorCard';
import CreatorTitle from './commonElements/creatorTitle';
import { LomavisOverlayToolTip1 } from '@/lomavisSharedUi/atoms/overlays/lomavisOverlayToolTip1/lomavisOverlayToolTip1';
import { LomavisMoreInfo } from '@/lomavisSharedUi/atoms/tooltips/LomavisMoreInfo';

interface Props {
  platform?: string;
  showSeparator?: boolean;
}

export const InstagramGraduationStrategy: React.FC<Props> = ({
  platform = INSTAGRAM,
  showSeparator = false
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const postData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postData[platform]
  );
  const postTypeSelected = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postTypeSelected[platform]
  );

  const graduationStrategy =
    postData?.additional_publication_data?.instagram_graduation_strategy;

  if (postTypeSelected !== POST_TYPE_TRIAL_REEL_KEY) return null;

  const body = (
    <>
      <div className="d-flex flex-column mb-3">
        {showSeparator && (
          <div className="d-flex align-items-center mb-2">
            <i className="fa-duotone fa-trophy me-2"></i>
            <span>
              {t('lomavisCreator.additionalOptions.graduation_strategy')}
            </span>
            <LomavisMoreInfo text={t('graduation_strategy.moreInfo')} />
          </div>
        )}
        <select
          className="form-select form-select-sm w-auto"
          value={graduationStrategy || GRADUATION_STRATEGY_MANUAL}
          onChange={(e) =>
            dispatch(
              setPostDataAttribute({
                platform,
                attribute: 'additional_publication_data',
                value: {
                  ...(postData?.additional_publication_data || {}),
                  instagram_graduation_strategy: e.target.value,
                  instagram_trial_reel_enabled: true
                }
              })
            )
          }
        >
          <option value={GRADUATION_STRATEGY_MANUAL}>
            {t('lomavisCreator.additionalOptions.graduation_strategy_manual')}
          </option>
          <option value={GRADUATION_STRATEGY_SS_PERFORMANCE}>
            {t(
              'lomavisCreator.additionalOptions.graduation_strategy_ss_performance'
            )}
          </option>
        </select>
      </div>
      {showSeparator && <CreatorVerticalSeparator />}
    </>
  );

  if (!showSeparator) {
    return (
      <CreatorCard>
        <div className="w-100 h-100 d-flex flex-column">
          <CreatorTitle title="graduation_strategy" tooltipLink={t("lomavisCreator.link.instagram_test_reel")} />
          {body}
        </div>
      </CreatorCard>
    );
  }

  return body;
};

export default InstagramGraduationStrategy;
